// src/NameTable.js
import React from 'react';

function NameTable({ people, onNameClick }) {
  // Split the list into two halves for two columns of tables
  const mid = Math.ceil(people.length / 2);
  const leftPeople = people.slice(0, mid);
  const rightPeople = people.slice(mid);

  return (
    <div className="tables-container">
      <table className="beer-table">
        <thead>
          <tr>
            <th style={{ width: "80%" }}>Name</th>
            <th style={{ width: "20%" }}>#</th>
          </tr>
        </thead>
        <tbody>
          {leftPeople.map((person) => (
            <tr key={person.id}>
              <td onClick={() => onNameClick(person.id, person.beers)} style={{ cursor: 'pointer' }}>
                {person.name}
              </td>
              <td>{person.beers}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <table className="beer-table">
        <thead>
          <tr>
            <th style={{ width: "80%" }}>Name</th>
            <th style={{ width: "20%" }}>#</th>
          </tr>
        </thead>
        <tbody>
          {rightPeople.map((person) => (
            <tr key={person.id}>
              <td onClick={() => onNameClick(person.id, person.beers)} style={{ cursor: 'pointer' }}>
                {person.name}
              </td>
              <td>{person.beers}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default NameTable;
